import React, { useEffect, useState, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
import { ThankYouPage } from './pages/ThankYouPage';
export type PageType = 'sales' | 'thankyou';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  const [currentPage, setCurrentPage] = useState<PageType>('sales');
  // Meta Pixel
  useEffect(() => {
    if (window.fbq) return;
    const f = window;
    const b = document;
    const n = 'script';
    (function (f: any, b: any, e: any, v: string) {
      if (f.fbq) return;
      const t: any = f.fbq = function (...args: any[]) {
        t.callMethod ? t.callMethod.apply(t, args) : t.queue.push(args);
      };
      if (!f._fbq) f._fbq = t;
      t.push = t;
      t.loaded = true;
      t.version = '2.0';
      t.queue = [];
      const s = b.createElement(e) as HTMLScriptElement;
      s.async = true;
      s.src = v;
      const fjs = b.getElementsByTagName(e)[0];
      fjs?.parentNode?.insertBefore(s, fjs);
    })(f, b, n, 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '904978025482552');
    window.fbq('track', 'PageView');
  }, []);
  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  const navigate = (page: PageType) => {
    setCurrentPage(page);
  };
  return <div className="min-h-screen bg-gradient-to-b from-navy-900 to-navy-800 text-offwhite font-sans" data-id="element-0">
      {currentPage === 'sales' && <SalesPage navigate={navigate} data-id="element-1" />}
      {currentPage === 'thankyou' && <ThankYouPage navigate={navigate} data-id="element-2" />}
    </div>;
}